import React from 'react';
import PropTypes from 'prop-types';
import Row from '../../../../core/layout/Row';
import Column from '../../../../core/layout/Column';
import TextInput from '../../../../core/form/TextInput';
import Audios from '../inputs/Audios';
import get from 'lodash/get';
import TranslationInputContainer from '../inputs/TranslationInputContainer';

const MeaningsAssociatingItemForm = props => {
  return (
    <div>
      <Row>
        <Column size={12}>
          <TextInput
            label="Vocabulary"
            required
            disabled={props.disabled || props.submitting}
            value={get(props.values, 'text', '')}
            onChange={value => props.onChange('text', value)}
            errorText={get(props.errors, 'text', '')}
          />
        </Column>
      </Row>
      <Row>
        <Column size={12}>
          <Audios
            onChange={props.onChange}
            audioPath="audio"
            values={props.values}
            disabled={props.disabled || props.submitting}
            errors={props.errors}
          />
        </Column>
      </Row>
      <Row>
        <Column size={12}>
          <TextInput
            label="The vocabulary definition"
            required
            value={props.values.postPhrase}
            onChange={value => props.onChange('postPhrase', value)}
            disabled={props.disabled || props.submitting}
            errorText={get(props.errors, 'postPhrase', '')}
          />
        </Column>
      </Row>
      <Row>
        <TranslationInputContainer
          onChange={props.onChange}
          submitting={props.submitting}
          disabled={props.disabled}
          errors={props.errors}
          values={props.values}
        />
      </Row>
      <Row>
        <Column size={12}>
          <Audios
            onChange={props.onChange}
            values={props.values}
            label="vocabulary definition"
            audioPath="postPhraseAudio"
            generatedAudioPath="generatedPostPhraseAudio"
            disabled={props.disabled || props.submitting}
            errors={props.errors}
          />
        </Column>
      </Row>
    </div>
  );
};

MeaningsAssociatingItemForm.propTypes = {
  values: PropTypes.object,
  onChange: PropTypes.func.isRequired,
  errors: PropTypes.object,
  submitting: PropTypes.bool,
  disabled: PropTypes.bool,
};

export default MeaningsAssociatingItemForm;
